// assets/product-engraving.js
import { Component } from '@theme/component';

/**
 * @typedef {object} ProductEngravingRefs
 * @property {HTMLButtonElement} toggleButton - The toggle button.
 * @property {HTMLElement} toggleLabel - The label span inside the toggle button.
 * @property {HTMLElement} fieldWrapper - The wrapper around the text input.
 * @property {HTMLInputElement} textInput - The engraving text input.
 */

/**
 * A custom element that reveals an inline engraving text field on click,
 * and wires the input up as a cart line item property.
 * @extends Component<ProductEngravingRefs>
 */
class ProductEngraving extends Component {
  handleToggle() {
    const { toggleButton, toggleLabel, fieldWrapper, textInput } = this.refs;
    const isOpen = toggleButton.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      fieldWrapper.hidden = true;
      textInput.disabled = true;
      toggleButton.setAttribute('aria-expanded', 'false');
      toggleLabel.textContent = this.dataset.addLabel ?? toggleLabel.textContent;
    } else {
      fieldWrapper.hidden = false;
      textInput.disabled = false;
      toggleButton.setAttribute('aria-expanded', 'true');
      toggleLabel.textContent = this.dataset.removeLabel ?? toggleLabel.textContent;
      textInput.focus();
    }
  }
}

customElements.define('product-engraving-component', ProductEngraving);
